import React from 'react';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Search, Filter } from 'lucide-react';
import { toPersianDigits } from '../../utils/persian';
import { Link } from 'react-router-dom';
const policies = [{
  id: 1,
  type: 'بیمه شخص ثالث',
  subtitle: 'پژو ۲۰۶ - ۱۴۰۲',
  company: 'بیمه ایران',
  expiry: '1403/12/29',
  number: '123456789',
  status: 'active',
  icon: '🚗'
}, {
  id: 2,
  type: 'بیمه آتش‌سوزی',
  subtitle: 'منزل مسکونی',
  company: 'بیمه پاسارگاد',
  expiry: '1403/09/15',
  number: '987654321',
  status: 'warning',
  icon: '🏠'
}, {
  id: 3,
  type: 'بیمه بدنه',
  subtitle: 'پژو ۲۰۶ - ۱۴۰۲',
  company: 'بیمه دانا',
  expiry: '1402/05/20',
  number: '456123789',
  status: 'expired',
  icon: '🚗'
}];
export function PoliciesPage() {
  return <CustomerLayout data-id="element-572">
      <div className="space-y-6" data-id="element-573">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-574">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-575">بیمه‌نامه‌های من</h1>
          <div className="flex gap-2 w-full md:w-auto" data-id="element-576">
            <div className="relative flex-1 md:w-64" data-id="element-577">
              <Search className="absolute right-3 top-3 h-4 w-4 text-gray-400" data-id="element-578" />
              <Input placeholder="جستجو..." className="pr-9" data-id="element-579" />
            </div>
            <Button variant="outline" data-id="element-580">
              <Filter className="h-4 w-4 ml-2" data-id="element-581" />
              فیلتر
            </Button>
          </div>
        </div>

        <div className="grid gap-4" data-id="element-582">
          {policies.map(policy => <Card key={policy.id} className="hover:shadow-md transition-shadow" data-id="element-583">
              <CardContent className="p-6" data-id="element-584">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-585">
                  <div className="flex items-center gap-4" data-id="element-586">
                    <div className="h-12 w-12 rounded-lg bg-gray-100 flex items-center justify-center text-2xl" data-id="element-587">
                      {policy.icon}
                    </div>
                    <div data-id="element-588">
                      <h3 className="font-bold text-gray-900" data-id="element-589">{policy.type}</h3>
                      <p className="text-sm text-gray-500" data-id="element-590">{policy.subtitle}</p>
                    </div>
                  </div>

                  <div className="flex flex-wrap items-center gap-4 md:gap-8 text-sm text-gray-600" data-id="element-591">
                    <div data-id="element-592">
                      <span className="block text-gray-400 text-xs" data-id="element-593">
                        شرکت بیمه
                      </span>
                      <span className="font-medium" data-id="element-594">{policy.company}</span>
                    </div>
                    <div data-id="element-595">
                      <span className="block text-gray-400 text-xs" data-id="element-596">
                        شماره بیمه‌نامه
                      </span>
                      <span className="font-medium" data-id="element-597">
                        {toPersianDigits(policy.number)}
                      </span>
                    </div>
                    <div data-id="element-598">
                      <span className="block text-gray-400 text-xs" data-id="element-599">
                        تاریخ انقضا
                      </span>
                      <span className="font-medium" data-id="element-600">
                        {toPersianDigits(policy.expiry)}
                      </span>
                    </div>
                    <div data-id="element-601">
                      {policy.status === 'active' && <Badge variant="success" data-id="element-602">فعال</Badge>}
                      {policy.status === 'warning' && <Badge variant="warning" data-id="element-603">نیاز به تمدید</Badge>}
                      {policy.status === 'expired' && <Badge variant="destructive" data-id="element-604">منقضی شده</Badge>}
                    </div>
                  </div>

                  <div className="flex gap-2 w-full md:w-auto mt-4 md:mt-0" data-id="element-605">
                    <Link to={`/policies/${policy.id}`} data-id="element-606">
                      <Button variant="outline" size="sm" data-id="element-607">
                        جزئیات
                      </Button>
                    </Link>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </CustomerLayout>;
}